import { useMemo } from 'react';
import { usePrecomputedEmbeddings } from '@shared/utils/search';
import type { StationeryTemplate } from '@apps/card/types/stationeryTemplate.types';
import type { ColorHits } from './useColorHits';
import type { TemplateFacetIndex } from './templateFacetMatching.types';
import { buildTemplateFacetIndex, colorOptionsByTemplateId } from './templateFacetMatching';

/**
 * The facet options of every template, built once per catalog, embeddings index and colour hits.
 * A filter toggle only reads it, so the filter and the counts never re-derive a template's options.
 *
 * Colour comes only from the index, one hit per colorway (or the base row for a card that has
 * none), so a colour filter sees every colorway of a card rather than a single palette.
 */
export const useTemplateFacetIndex = (templates: ReadonlyArray<StationeryTemplate>, colorHits: ColorHits): TemplateFacetIndex => {
  const { themes, keywordGroups } = usePrecomputedEmbeddings();
  return useMemo(
    () => buildTemplateFacetIndex(templates, { themes, keywordGroups, colorOptionsByTemplateId: colorOptionsByTemplateId(colorHits.all) }),
    [templates, themes, keywordGroups, colorHits],
  );
};
